import React from "react";
import { Grid, Checkbox, FormControlLabel } from "@material-ui/core";
import { PublishedComponent, TextInput, useModulesManager, useTranslations } from "@openimis/fe-core";

const ClaimPurchaseRequestReport = (props) => {
  const { values, setValues } = props;
  const modulesManager = useModulesManager();
  const { formatMessage } = useTranslations("claim", modulesManager);

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <TextInput
          module="claim"
          label="ClaimPurchaseRequestReport.title"
          value={values.title || ""}
          onChange={(title) => setValues({ ...values, title })}
        />
      </Grid>
      <Grid item>
        <PublishedComponent
          pubRef="core.DatePicker"
          value={values.dateStart}
          required
          module="claim"
          label={formatMessage("ClaimPurchaseRequestReport.dateStart")}
          onChange={(dateStart) => setValues({ ...values, dateStart })}
        />
      </Grid>
      <Grid item>
        <PublishedComponent
          pubRef="core.DatePicker"
          value={values.dateEnd}
          required
          module="claim"
          label={formatMessage("ClaimPurchaseRequestReport.dateEnd")}
          onChange={(dateEnd) => setValues({ ...values, dateEnd })}
        />
      </Grid>
      <Grid item>
        <PublishedComponent
          pubRef="claim.ClaimStatusPicker"
          value={values.status}
          module="claim"
          label="claim.claimStatus"
          onChange={(status) => setValues({ ...values, status })}
        />
      </Grid>
      <Grid item>
        <PublishedComponent
          pubRef="location.HealthFacilityPicker"
          value={values.hf}
          onChange={(hf) => setValues({ ...values, hf })}
          label={formatMessage("ClaimPurchaseRequestReport.hf")}
        />
      </Grid>
      <Grid item>
        <TextInput
          module="claim"
          label="ClaimPurchaseRequestReport.requestedBy"
          value={values.requestedBy || ""}
          onChange={(requestedBy) => setValues({ ...values, requestedBy })}
        />
      </Grid>
      <Grid item>
        <TextInput
          module="claim"
          label="ClaimPurchaseRequestReport.paymentTo"
          value={values.paymentTo || ""}
          onChange={(paymentTo) => setValues({ ...values, paymentTo })}
        />
      </Grid>
      <Grid item>
        <TextInput
          module="claim"
          label="ClaimPurchaseRequestReport.bankAccountNo"
          value={values.bankAccountNo || ""}
          onChange={(bankAccountNo) => setValues({ ...values, bankAccountNo })}
        />
      </Grid>
      <Grid item>
        <TextInput
          module="claim"
          label="ClaimPurchaseRequestReport.bankAccountHolderName"
          value={values.bankAccountHolderName || ""}
          onChange={(bankAccountHolderName) => setValues({ ...values, bankAccountHolderName })}
        />
      </Grid>
      <Grid item>
        <TextInput
          module="claim"
          label="ClaimPurchaseRequestReport.verifiedBy"
          value={values.verifiedBy || ""}
          onChange={(verifiedBy) => setValues({ ...values, verifiedBy })}
        />
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!values.typeOfPurchaseServices}
              onChange={(event) =>
                setValues({ ...values, typeOfPurchaseServices: event.target.checked })
              }
              color="primary"
            />
          }
          label={formatMessage("ClaimPurchaseRequestReport.typeOfPurchaseServices")}
        />
      </Grid>
    </Grid>
  );
};

export default ClaimPurchaseRequestReport;
